document.addEventListener( 'DOMContentLoaded', function() {
	document.querySelectorAll( '.blog-related' ).forEach( function( related ) {
		const track = related.querySelector( '.related-track' );
		const prev = related.querySelector( '.related-prev' );
		const next = related.querySelector( '.related-next' );

		if ( ! track || ! prev || ! next ) {
			return;
		}

		next.addEventListener( 'click', function() {
			track.scrollBy( { left: track.clientWidth * 0.8, behavior: 'smooth' } );
		} );

		prev.addEventListener( 'click', function() {
			track.scrollBy( { left: track.clientWidth * -0.8, behavior: 'smooth' } );
		} );
	} );
} );
